import {useSelector} from 'react-redux';

import {useGetCustomerEmail} from 'hooks/getCustomerData/getCustomerData';
import {useGetRegions} from 'hooks/location/location';
import {BillingDetailsType} from 'types/stripeType';

import {getBillingAddress} from '../../store/selectors/billingAddress/billingAddress';

/**
 * Get billing address for stripe
 * @param {AddressType} address - current address
 * @param {LocationDefaultStateType} location - current location
 * @param {string} email - current email
 * @return {BillingDetailsType} address for stripe
 */
export const useGetAddressForStripe = (): BillingDetailsType => {
    const address = useSelector(getBillingAddress);
    const {regions: states} = useGetRegions(address.country.value);
    const email = useGetCustomerEmail();

    const currentAddress: {[key: string]: string} = Object.keys(address).reduce(
        (acc, key) => ({...acc, [key]: address[key].value}),
        {},
    );

    currentAddress.state =
        (states?.[currentAddress.country] || [])?.find(
            country => country.label === currentAddress.state,
        )?.value || currentAddress.state;

    return {
        address: {
            city: currentAddress.city,
            country: currentAddress.country,
            line1: currentAddress.address,
            line2: currentAddress.other,
            postal_code: currentAddress.postal,
            state: currentAddress.state,
        },
        email: String(currentAddress.email || email),
        name: `${currentAddress.firstName} ${currentAddress.lastName}`,
        phone: currentAddress.phone,
    };
};
